exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-timeseries {\r\n  position: relative;\r\n  min-height: 320px;\r\n}\r\n\r\n.ai-timeseries canvas {\r\n  width: 100%;\r\n  height: 320px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/ai-statistics-timeseries/ai-statistics-timeseries.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/ai-statistics-timeseries/ai-statistics-timeseries.component.css
// module chunks = main